import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/cfr-logs'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getLink: NoParamEndpointConstructor
  download: NoParamEndpointConstructor
}

export const cfrLogsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  getLink: () => `${baseUrl}/link`,
  download: () => `${baseUrl}/download`,
}
